
import Component from '../../../assets/scripts/modules/component'
import throttle from 'lodash/throttle'
import supportsPassiveListener from '../../../vendor/scripts/fabrique/modules/supports-passive-listener'

const BREAKPOINT_NOTEBOOK = 1180

class ChapterSideListComponent extends Component {
  init () {
    this.wrapper = this.element.querySelector('.chapter-side-list__list-wrapper')
    this.button = this.element.querySelector('.chapter-side-list__button')
    this.container = document.body.querySelector('.page-sections__content')
    this.list = this.wrapper.querySelector('.chapter-list')

    if (!this.wrapper || !this.button || !this.container || !this.list) {
      return
    }

    this.button.addEventListener('click', event => this.onClick(event))

    const throttledResize = throttle(() => window.requestAnimationFrame(() => this.onResize()), 500, { leading: false, trailing: true })
    window.addEventListener('resize', () => throttledResize(), supportsPassiveListener ? { passive: true } : null)
    throttledResize()
  }

  onClick (event) {
    if (window.innerWidth >= BREAKPOINT_NOTEBOOK) {
      return
    }

    event.preventDefault()

    if (this.wrapper.getAttribute('data-expanded') !== 'true') {
      this.expandListWrapper()
    } else {
      this.retractListWrapper()
    }
  }

  onResize () {
    if (window.innerWidth >= BREAKPOINT_NOTEBOOK) {
      this.expandListWrapper()
      this.updateContentHeight()
    } else {
      this.retractListWrapper()
    }
  }

  expandListWrapper () {
    this.wrapper.setAttribute('data-expanded', true)
    this.button.setAttribute('aria-expanded', true)
  }

  retractListWrapper () {
    this.wrapper.setAttribute('data-expanded', false)
    this.button.setAttribute('aria-expanded', false)
  }

  updateContentHeight () {
    const style = this.container.currentStyle || window.getComputedStyle(this.container)
    const margin = parseInt(style.marginBottom, 10)

    this.container.style.minHeight = `${this.list.clientHeight + margin}px`
  }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.chapter-side-list')) {
    element.instance = element.instance || new ChapterSideListComponent(element)
  }
})
